import { render, staticRenderFns } from "./RadioIcon.vue?vue&type=template&id=2682d956&scoped=true"
import script from "./RadioIcon.vue?vue&type=script&lang=ts"
export * from "./RadioIcon.vue?vue&type=script&lang=ts"
import style0 from "./RadioIcon.vue?vue&type=style&index=0&id=2682d956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682d956",
  null
  
)

export default component.exports